<div class="matero-error-wrap">
  <div class="matero-error-code">{{ code }}</div>
  @if (title) {
    <div class="matero-error-title">{{ title }}</div>
  }
  @if (message) {
    <div class="matero-error-message">{{ message }}</div>
  }
  @if (showHomeButton) {
    <div>
      <a mat-raised-button color="primary" routerLink="/">{{ 'common.back_home' | translate }}</a>
    </div>
  }
  @if (showLogoutButton) {
    <div>
      <button mat-raised-button color="primary" (click)="logout()">
        {{ 'common.logout' | translate }}
      </button>
    </div>
  }
</div>
